import { Typography } from 'antd';
import BaseLink from './link';
import BaseHeading from './heading';
import BaseBodyText from './bodyText';

export default Object.assign(Typography, {
	BaseLink,
	BaseHeading,
	BaseBodyText
});